import axios from 'axios';

export type UserSession = {
    jwtToken?: string;
    email?: string;
    authorStatus?: string;
    nickName?: string;
};

const USER_SESSION_KEYS = [
    'authorEmail',
    'authorStatus',
    'email',
    'jwtToken',
    'nickName',
    'identityVerificationId',
    'authorName',
] as const;

const hasValue = (value: unknown): value is string =>
    typeof value === 'string' && value.trim().length > 0;

export const clearStoredAuth = () => {
    USER_SESSION_KEYS.forEach(key => localStorage.removeItem(key));
    sessionStorage.removeItem('adminToken');
    delete axios.defaults.headers.common.Authorization;
};

export const saveUserSession = (session: UserSession) => {
    clearStoredAuth();

    if (hasValue(session.jwtToken)) {
        localStorage.setItem('jwtToken', session.jwtToken);
        axios.defaults.headers.common.Authorization = `Bearer ${session.jwtToken}`;
    }
    if (hasValue(session.email)) {
        localStorage.setItem('email', session.email);
    }
    if (hasValue(session.authorStatus)) {
        localStorage.setItem('authorStatus', session.authorStatus);
    }
    if (hasValue(session.nickName)) {
        localStorage.setItem('nickName', session.nickName);
    }
};

export const fetchAndSaveUserSession = async (loginToken: string): Promise<UserSession> => {
    const response = await axios.post('/api/sign/oauth2/who', null, {
        headers: {
            Authorization: `Bearer ${loginToken}`,
        },
    });

    const data = response.data ?? {};
    const session: UserSession = {
        jwtToken: hasValue(data.token) ? data.token : loginToken,
        email: data.email,
        authorStatus: data.authorStatus,
        nickName: data.nickName,
    };

    saveUserSession(session);
    return session;
};
